import {IGetAIReviewJobDetailsResponse} from '../../../../../api/types/aiReview.type';

export const PROTOCOL_VERSION_DISPLAY_MODE = {
  MANUAL: 'manual',
  PROTOCOL_NAME: 'protocolName',
  MODIFIED_SAVE_AS_NEW: 'modifiedSaveAsNew',
  MODIFIED_SAVED: 'modifiedSaved',
} as const;

export type ProtocolVersionDisplayMode =
  (typeof PROTOCOL_VERSION_DISPLAY_MODE)[keyof typeof PROTOCOL_VERSION_DISPLAY_MODE];

const hasProtocolVersionValue = (value?: string | null): boolean =>
  Boolean(value?.trim());

export const resolveProtocolVersionMode = (
  jobDetails?: IGetAIReviewJobDetailsResponse | null
): ProtocolVersionDisplayMode => {
  if (!jobDetails) {
    return PROTOCOL_VERSION_DISPLAY_MODE.PROTOCOL_NAME;
  }

  const {
    isManual,
    isProtocolModified,
    reviewProtocolVersion,
    parentProtocolVersion,
  } = jobDetails;

  if (isManual) {
    return PROTOCOL_VERSION_DISPLAY_MODE.MANUAL;
  }

  if (isProtocolModified && hasProtocolVersionValue(parentProtocolVersion)) {
    return hasProtocolVersionValue(reviewProtocolVersion)
      ? PROTOCOL_VERSION_DISPLAY_MODE.MODIFIED_SAVED
      : PROTOCOL_VERSION_DISPLAY_MODE.MODIFIED_SAVE_AS_NEW;
  }

  return PROTOCOL_VERSION_DISPLAY_MODE.PROTOCOL_NAME;
};

export const getProtocolVersionName = (
  jobDetails?: IGetAIReviewJobDetailsResponse | null
): string => {
  return jobDetails?.reviewProtocolVersion?.trim() ?? '';
};

export const getParentProtocolVersionName = (
  jobDetails?: IGetAIReviewJobDetailsResponse | null
): string => {
  return jobDetails?.parentProtocolVersion?.trim() ?? '';
};

export const shouldShowDraftProtocolChangedIcon = (
  jobDetails?: IGetAIReviewJobDetailsResponse | null
): boolean => {
  if (!jobDetails?.isDraftProtocolChangedAfterJobModified) {
    return false;
  }

  return (
    resolveProtocolVersionMode(jobDetails) ===
    PROTOCOL_VERSION_DISPLAY_MODE.PROTOCOL_NAME
  );
};
